import $ from 'jquery';
import findContainer from './findContainer';
import variantImageMap from './variantImageMap';
import checkDupes from './checkDupes';
import generateAllInOneCarousel from './generateAllInOneCarousel';
import generateOption1Carousels from './generateOption1Carousels';
import generateComboCarousels from './generateComboCarousels';

export default () => {

  $(document).trigger('productOverviewCarouselsWillPopulate');
  
  const $container = findContainer();
  const $carousels_container = $('[data-product-images]', $container);
  const $carousels_data = $carousels_container.data();
  const carousels_scope = $carousels_data.carouselScope;
  const product_json = JSON.parse($('[data-product-json]', $container).html());
  const variant_image_map = variantImageMap(product_json);

  let duplicate_combo_images = false;
  let duplicate_option1_images = false;
  let effective_scope = carousels_scope;

  if (carousels_scope === 'combo' && product_json.options.length > 1) {
    // Check if every option1/option2 combo has a unique image
    duplicate_combo_images = checkDupes(variant_image_map, 'combo');
  }    
  if (carousels_scope === 'option1' || duplicate_combo_images || product_json.options.length === 1) {
    // Check if every option1 has a unique image
    duplicate_option1_images = checkDupes(variant_image_map, 'option1');
  }
 
  if (carousels_scope === 'all' || product_json.variants.length === 1 || duplicate_option1_images) {
    effective_scope = 'all';
  } else if (carousels_scope === 'option1' || product_json.options.length === 1 || duplicate_combo_images) {
    effective_scope = 'option1';
  }

  if (effective_scope === 'combo') {
    return generateComboCarousels(product_json, variant_image_map, $carousels_data, $container);
  }
  if (effective_scope === 'option1') {
    return generateOption1Carousels(product_json, variant_image_map, $carousels_data, $container);      
  }

  return generateAllInOneCarousel(product_json, variant_image_map, $carousels_data, $container);
};